






























import {Component, Vue} from 'vue-property-decorator';
import * as microtime from '@/lib/microtime';

@Component
export default class NumberToStringConverter extends Vue {
    input: string = microtime.now().toString();
    output: string = '';
    errors: string[] = [];

    onFormSubmit() {
        this.output = '';
        this.errors = [];
        if (!microtime.isMicrotimeNumber(this.input)) {
            this.errors.push('Input not supported.');
            return;
        }

        this.output = microtime.toISOString(microtime.parseNumber(this.input));
    }

    get inputValid() {
        return microtime.isMicrotimeNumber(this.input);
    }
}
